import { globalCss } from 'config/stitches/stitches';

const globalStyle = globalCss({
  '*': {
    boxSizing: 'border-box',
  },

  body: {
    margin: 0,
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    background: '$BACKGROUND_SECONDARY',
  },

  'html, body': {
    margin: 0,
    padding: 0,
    minHeight: '100%',
  },

  '#root': {
    minHeight: '100%',
  },
});

export default globalStyle;
